module.exports = __webpack_public_path__ + "img/receipt.d84ceed6.svg";